"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.divisionRoundingDefaultValue = exports.divisionRoundingSchema = void 0;
const zod_1 = require("zod");
exports.divisionRoundingSchema = zod_1.z.object({
    decimals: zod_1.z.number().gt(0).int(),
    round_mode: zod_1.z.union([zod_1.z.literal('up'), zod_1.z.literal('truncate')]),
});
const defaultValue = {
    decimals: 2,
    round_mode: 'truncate',
};
exports.divisionRoundingDefaultValue = JSON.stringify(defaultValue, null, '\t');
